import axiosInstance from '../config/axios.js';

const plStatutoryService = {
  list: async (params = {}) => {
    const response = await axiosInstance.get('/pl-statutory-items', { params });
    return response.data;
  },

  create: async (payload) => {
    const response = await axiosInstance.post('/pl-statutory-items', payload);
    return response.data;
  },

  update: async (itemId, payload) => {
    const response = await axiosInstance.put(`/pl-statutory-items/${itemId}`, payload);
    return response.data;
  },

  togglePayment: async (itemId, payload = {}) => {
    const response = await axiosInstance.post(
      `/pl-statutory-items/${itemId}/toggle-payment`,
      payload,
    );
    return response.data;
  },

  remove: async (itemId) => {
    const response = await axiosInstance.delete(`/pl-statutory-items/${itemId}`);
    return response.data;
  },
};

export default plStatutoryService;
